import { forwardRef } from "react";
import AttachmentsField, {
  AttachmentsFieldProps
} from "@/components/controls/AttachmentsField";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";

// Record detail views resolve every custom field through one switch, and a hook
// cannot be called from a case branch — so the rollout gate lives here, the same
// way FileUploadControl carries it for the registry-driven question renderer.
export const DetailAttachmentsField = forwardRef<
  HTMLDivElement,
  AttachmentsFieldProps
>((props, ref) => {
  const { enabled: isFileFieldEnabled, loading: isFileFieldFlagLoading } =
    useFeatureFlag(FeatureFlags.CRM_9188_FILE_FIELD_MGMT);

  // Nothing rather than a fallback control: the stored value is attachment
  // JSON, and any generic editor would let the record be overwritten with it.
  if (isFileFieldFlagLoading || !isFileFieldEnabled) {
    return null;
  }

  return <AttachmentsField {...props} ref={ref} />;
});
DetailAttachmentsField.displayName = "DetailAttachmentsField";
